import './FormDialog.css';

import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
	Divider,
} from '@mui/material';
import { useSelector } from 'react-redux';

export function FormDialog({
	title,
	isOpen,
	closeHandler,
	primaryAction,
	secondaryAction,
	isDisabled = false,
	canBeCanceled = true,
	children,
}) {
	const { t } = useSelector(redux => redux.store);

	return (
		<Dialog open={isOpen} onClose={closeHandler} fullWidth maxWidth="md">
			<div className="form-dialog">
				<DialogTitle>{title}</DialogTitle>
				<Divider />
				<DialogContent>
					{children}
				</DialogContent>
				<DialogActions>
					{ canBeCanceled && (
						<Button onClick={closeHandler}>
							{t.text_area_delete_cancel}
						</Button>
					)}
					{secondaryAction && (
						<Button
							variant="contained"
							color="secondary"
							disabled={isDisabled}
							onClick={secondaryAction.handler}
						>
							{secondaryAction.label}
						</Button>
					)}
					<Button
						variant="contained"
						color="primary"
						disabled={isDisabled}
						onClick={primaryAction.handler}
					>
						{primaryAction.label}
					</Button>
				</DialogActions>
			</div>
		</Dialog>
	);
}
